module.exports = __webpack_public_path__ + "img/387042.52609f25.svg";